import WebLayout from './EmptyCellLayout.web';
import MobileLayout from './EmptyCellLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;